import { formatPhoneNumber } from '@@utils/string';
import { ContentText } from '@american-autonomy/rantizo-ui';

import EditableSection from 'components/EditableSection';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const UserDetailsEditCard: FunctionComponent<Props> = ({
    editable = false,
    email = '',
    firstName = '',
    lastName = '',
    onEdit,
    phoneNumber = '',
    testId = TEST_ID
}) => {
    const { TITLE } = useTranslation();

    const formattedPhoneNumber = formatPhoneNumber(phoneNumber) ?? '';

    return (
        <EditableSection editable={editable} onEdit={onEdit} testId={testId} title={TITLE}>
            <ContentText text={`${firstName} ${lastName}`} />

            <ContentText text={formattedPhoneNumber} />

            <ContentText text={email} />
        </EditableSection>
    );
};

export default UserDetailsEditCard;
